export const StatusType = [
  'Wating',
  'Ordering',
  'Arrived',
  'Delivered',
  'Out Of Stock',
  'Ready',
  'Finding',
  '',
  'Instore Purchase',
  'Returning',
  '',
  'Uncollected',
  'Returned',
  'Found',
  'Prepared',
  'Agent Arrived',
  'Merchant Shipped',
  'Shipper Sent',
  'Damaged Item',
  'Wrong Item',
  'Merchant Cancelled',
  'Discountined'
]